import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PopoverDeleteSchedulePageRoutingModule } from './popover-delete-schedule-routing.module';

import { PopoverDeleteSchedulePage } from './popover-delete-schedule.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PopoverDeleteSchedulePageRoutingModule
  ],
  declarations: [PopoverDeleteSchedulePage]
})
export class PopoverDeleteSchedulePageModule {}
